export default "__VITE_ASSET__27cc7178__"